import { render, staticRenderFns } from "./q-area.vue?vue&type=template&id=0eb37be5&scoped=true&"
import script from "./q-area.vue?vue&type=script&lang=js&"
export * from "./q-area.vue?vue&type=script&lang=js&"
import style0 from "./q-area.vue?vue&type=style&index=0&id=0eb37be5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb37be5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yangxinyuan/vhall/vhall_questionnaire_service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eb37be5')) {
      api.createRecord('0eb37be5', component.options)
    } else {
      api.reload('0eb37be5', component.options)
    }
    module.hot.accept("./q-area.vue?vue&type=template&id=0eb37be5&scoped=true&", function () {
      api.rerender('0eb37be5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/questionnaire/q-area.vue"
export default component.exports